module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    style: ({
      'min-height': _vm.beginHeight + 'px',
      'min-width': '1000px'
    })
  }, [_c('hdHead', {
    attrs: {
      "cTitle": _vm.plive.lName,
      "cEnd": _vm.plive.lEndDt,
      "cIcon": _vm.plive.lBackUrl,
      "cStart": _vm.plive.lStartDt
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "38px",
      "margin-bottom": "16px",
      "font-size": "20px"
    }
  }, [_vm._v("选择直播会场")]), _vm._v(" "), _c('ul', {
    ref: "list-box",
    staticClass: "live-list clear"
  }, _vm._l((_vm.liveList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "clear",
      class: [i % 2 === 0 ? '' : 'margin0'],
      style: ({
        width: _vm.liveItemWidth + 'px'
      })
    }, [_c('div', {
      staticClass: "left"
    }, [_c('i', {
      staticClass: "edit",
      staticStyle: {
        "margin-top": "-8px"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "inline-block",
        "max-width": "240px",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n          " + _vm._s(item.roomSubject) + "\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('i', {
      staticClass: "room-icon"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px",
        "color": "#717171"
      }
    }, [_vm._v(_vm._s(item.roomName))])])]), _vm._v(" "), _c('div', {
      staticClass: "right right-content;",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('i', {
      class: ("living" + (item.liveStatus))
    }), _vm._v(" "), (item.roomlivestatus > 0) ? _c('span', {
      staticStyle: {
        "color": "#32b16c",
        "font-size": "16px"
      }
    }, [_vm._v("正在直播中")]) : _vm._e(), _vm._v(" "), (item.roomlivestatus === -1) ? _c('span', {
      staticStyle: {
        "color": "#b6b6b6",
        "font-size": "16px"
      }
    }, [_vm._v("直播未开始")]) : _vm._e(), _vm._v(" "), (item.roomlivestatus === -2) ? _c('span', {
      staticStyle: {
        "color": "#00a0e9",
        "font-size": "16px"
      }
    }, [_vm._v("直播已结束")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "go-in",
      on: {
        "click": function($event) {
          _vm.goLivePage(item.roomlivestatus)
        }
      }
    }, [_vm._v("进入")])])])
  }))], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer1"
  }, [_c('img', {
    attrs: {
      "src": require("./bottom_logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef3b25a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl2/hudong/hudong.vue
// module id = 767
// module chunks = 10